<template>
  <article class="login">
    <section class="login__form_container f_background">
      <form class="login__form" @submit.prevent="signIn">
        <img class="login__logo" src="./../../assets/img/logo.png" alt="logo fusepong" />
        <h5>Inicio de Sesión</h5>
        <div class="login__input_field">
          <label><strong>Correo Electrónico</strong></label>
          <v-text-field flat solo placeholder="Escribe tu correo de acceso" v-model="loginForm.email"
            @blur="$v.loginForm.email.$touch()" />
        </div>
        <div class="login__input_field">
          <label>Contraseña</label>
          <v-text-field type="password" placeholder="Escribe tu contraseña" flat solo v-model="loginForm.password"
            @blur="$v.loginForm.password.$touch()" />
        </div>
        <button class="login__button" type="submit">Ingresar</button>
      </form>
      <footer class="login__footer">
        <p>2025 Fusepong. Todos Los derechos reservados.</p>
      </footer>
    </section>
    <div class="login__background background_image"></div>
    <span class="login__big_circle"></span>
    <span class="login__small_circle"></span>
  </article>
</template>
<script lang="js">
import { required, email, minLength } from "vuelidate/lib/validators";
import AuthService from "../../services/AuthService";

export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      backgroundImg: '../../assets/img/fondo-login.png'
    }
  },
  validations: {
    loginForm: {
      email: { required, email },
      password: { required, minLength: minLength(6) },
    }
  },
  methods: {
    async signIn() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        alert('Verificar formulario.');
        return;
      }
      this.setLoader(true);
      try {
        const data = this.encrypt({attributes: this.loginForm}).toString();
        const resp = await AuthService.signIn(data, {"X-Device-ID": localStorage.getItem('device_id')});
        if ( resp.data.data.attributes.user_roles.includes('admin')){
          if (resp.data.meta) {
            localStorage.setItem('token', resp.data.meta.authentication_token);
            localStorage.setItem('companyId', resp.data.data.attributes.company);
            this.$store.commit('setToken', resp.data.meta.authentication_token);
            this.$store.commit('setCompanyId', resp.data.data.attributes.company);
            this.$store.commit('setEmail', resp.data.data.attributes.email);
            await this.$router.push('/dashboard');
          }
        } else {
          this.setLoader(false);
          alert('No tienes permisos para acceder.');
          this.loginForm = {
            email: '',
            password: '',
          };
        }
        
      } catch (err) {
        console.error(err);
        this.setLoader(false);
        alert('Credenciales invalidas.');
        this.loginForm = {
          email: '',
          password: '',
        }
      }
      this.setLoader(false);
    }
  }
}
</script>
<style>
.background_image {
  background-image: url('../../assets/img/fondo-login.png');
}

.f_background {
  background-image: url('../../assets/img/f-marca-agua.png');
}
</style>